import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';

@Component({
    selector: 'app-customer-activation',
    templateUrl: './customer-activation.component.html',
    styleUrls: ['./customer-activation.component.scss']
})
export class CustomerActivationComponent implements OnInit {
  @Input() public column : Array<{}> = [];
  @Input() public customerActivationReport : Array<object> = [];
  @Input() public totalRecords: number;
  @Output() public eventVal: EventEmitter<LazyLoadEvent> = new EventEmitter<LazyLoadEvent>();
  public constructor() { }

  public ngOnInit(): void {}
  public onLazyLoad(event:LazyLoadEvent) : void {
      this.eventVal.emit(event);
  }
}
